// extracted by mini-css-extract-plugin
export default {"light":"Context_light__aFj5Q","dark":"Context_dark__JoL7C"};